import { Pageable, PageableUtils } from '®shared/jsonapi';
import { JsonTypeDeriver } from '®shared/type-utils';

import { ListItem } from './list-item';

export interface PageableItems extends Pageable {
  items: ListItem[];
  pageOffset: number;
  totalPages: number;
}

export class PageableItemsUtilsClass implements JsonTypeDeriver<PageableItems> {
  /**
   * Adds derived properties to a pageable-items instance.
   *
   * @param {PageableItems} pageableItems - The pageable-items to extend.
   * @returns {PageableItems} - The pageable-items, with derived properties added
   **/
  addDerivedProperties(pageableItems: PageableItems): PageableItems {
    // add derived properties for Pageable
    return PageableUtils.addDerivedProperties(pageableItems) as PageableItems;
  }
}

export const LIST_ITEMS_PAGE_SIZE = 200;

export const PageableItemsUtils = new PageableItemsUtilsClass();

export const PAGEABLE_EMPTY_ITEMS = PageableItemsUtils.addDerivedProperties({
  items: [],
  pageOffset: 0,
  totalPages: 1,
  links: {
    self: null,
  },
  meta: {
    item_count: 0,
  },
});
